export const DEFAULT_AFFILIATE_LINK_COMMISSION_TEXT = '5%-15%'
export const METAPIC_PARTNER_IDENTIFIER = 'metapic'
export const METAPIC_HOMEPAGE = 'https://metapic.com/en'
